var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"component-user-form-content"},[_c('p',{staticClass:"component-user-form-content__description"},[_vm._t("description")],2),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }